import {Injectable} from '@angular/core';
import {LeModalService} from "../modal/le-modal.service";
import {ConfirmationDialogComponent} from "./confirmation-dialog.component";
import {TranslocoService} from "@jsverse/transloco";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(private modalService: LeModalService, private translocoService: TranslocoService) {
  }

  alert(question: string, description?: string, onNo: Function = null){
    return this.confirm(question, description, null, onNo, {
      showYes: false,
      noLabel: 'OK'
    });
  }

  confirm(question: string, description?: string, onYes: Function = null, onNo: Function = null, options: ConfirmationDialogOptions = null): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      let modalRef = this.modalService.show(ConfirmationDialogComponent, {
        initialState: {
          question: question,
          description: description,
          options: options
        },
        class: 'modal-sm'
      });

      modalRef.onHide$.subscribe(value1 => {
        if (onYes && value1.data){
          onYes();
        }
        if (onNo && !value1.data){
          onNo();
        }
        resolve(value1.data);
      });
    })
  }

  question(question: string, options: ConfirmationDialogOptions = null): Promise<boolean> {
    return this.confirm(question, null, null, null, options);
  }

  confirmTranslated(question: string, description?: string, options?: ConfirmationDialogOptions): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.getTranslations(question, description).subscribe(([translatedQuestion, translatedDescription]) => {
        let modalRef = this.modalService.show(ConfirmationDialogComponent, {
          initialState: {
            question: translatedQuestion,
            description: translatedDescription,
            options: options
          },
          class: 'modal-sm'
        });

        modalRef.onHide$.subscribe(value => {
          resolve(value.data);
        });
      });
    });
  }

  private getTranslations(question: string, description: string) {
    return this.translocoService.selectTranslate<string>([question, description].filter(value => value !== null)).pipe(take(1));
  }
}

export class ConfirmationDialogOptions {
  showYes?: boolean;
  showNo?: boolean;
  yesLabel?: string;
  noLabel?: string;
  hasSafetyCheck?: boolean;
  yesClass?: string;
  noClass?: string;
}
